import uuidv1 from 'uuid/v1';
import * as log from 'loglevel';

const DEFAULT_PLAN = 'conversion_funnel';
const PLAN_VERSION = 1;

export default {
  logPageView(eventName = 'cf_page_viewed', plan, planVersion) {
    const uuid = uuidv1();
    const urlParams = new URLSearchParams(window.location.search);
    const contentParam = urlParams.get('utm_content');
    const mediumParam = urlParams.get('utm_medium');
    const sourceParam = urlParams.get('utm_source');
    const campaignParam = urlParams.get('utm_campaign');
    const currentUser = (window.mParticle && window.mParticle.Identity && window.mParticle.Identity.getCurrentUser && window.mParticle.Identity.getCurrentUser()) || null;

    if (currentUser) {
      currentUser.setUserAttribute('$utm_content', contentParam);
      currentUser.setUserAttribute('$utm_medium', mediumParam);
      currentUser.setUserAttribute('$utm_source', sourceParam);
      currentUser.setUserAttribute('$utm_campaign', campaignParam);
    }

    const attributes = {
      uuid,
      created_at: new Date(),
      event_type: 'cf_page_viewed',
      title: document.title,
      url: window.location.href,
      search: window.location.search,
      referrer: document.referrer,
      path: window.location.pathname,
      content: contentParam,
      medium: mediumParam,
      source: sourceParam,
      campaign: campaignParam,
    };

    const customFlags = {
      'Google.Page': window.location.pathname,
      'Google.Title': document.title,
    };

    window.mParticle.logPageView(eventName, attributes, customFlags, {
      dataPlan: {
        planId: plan || DEFAULT_PLAN,
        planVersion: planVersion || PLAN_VERSION,
      },
    });
  },

  logEvent(eventName, customAttributes, customFlags = {}, eventType = window.mParticle.EventType.Other) {
    customAttributes.url = window.location.href;
    const googleLabel = eventName === 'cf_button_clicked' ? customAttributes.button_text : eventName;
    window.mParticle.logEvent(eventName, eventType, customAttributes, { 'Google.Label': googleLabel, ...customFlags });
    if (window.fbq) {
      if (eventName === 'cf_signup_successful') {
        window.fbq('track', 'CompleteRegistration', { content_name: 'signup', status: true });
      } else if (eventName === 'cf_subscription_created') {
        // needed for FB signal even if not actually starting trial
        window.fbq('track', 'StartTrial', {
          currency: customAttributes.currency,
          value: customAttributes.total_price,
          predicted_ltv: customAttributes.predicted_ltv,
        });
        window.fbq('track', 'Subscribe', {
          currency: customAttributes.currency,
          value: customAttributes.total_price,
          predicted_ltv: customAttributes.predicted_ltv,
        });
      }
    }
  },

  logProductAction(type, product, customAttributes, customFlags, transactionAttributes) {
    try {
      const mpProduct = window.mParticle.eCommerce.createProduct(product.name, product.sku, product.price, product.quantity);
      window.mParticle.eCommerce.logProductAction(
        type,
        mpProduct,
        customAttributes,
        customFlags,
        transactionAttributes,
      );
    } catch (e) {
      log.error(e);
    }
  },

  logPurchase(...args) {
    this.logProductAction.apply(null, [window.mParticle.ProductActionType.Purchase, ...args]);
  },

  addToCart(...args) {
    this.logProductAction.apply(null, [window.mParticle.ProductActionType.AddToCart, ...args]);
  },

};
